import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import LoaderBuildWishList from "../../Components/pageLoader/LoaderBuildWishList";

const RentalMainPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  const fetchCategories = useCallback(async () => {
    try {
      const response = await axios.get("https://server-gs.vercel.app/category");
      setCategories(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchCategories(); // Fetch data immediately
    const intervalId = setInterval(fetchCategories, 10000); // Fetch every 10 seconds

    return () => clearInterval(intervalId);
  }, [fetchCategories]);

  return (
    <div className="bg-rose-50">
      <div className="max-w-screen-4xl mx-auto p-4">
        <div className="flex flex-col justify-center items-center">
          <h1 className="text-center font-pacifico font-thin text-6xl text-rose-700 py-10">
            Rentals Items
          </h1>
          <div
            className="h-1 w-full mb-10"
            style={{
              background:
                "linear-gradient(to right, transparent, #6B021A, transparent)",
            }}
          ></div>
          {loading ? (
            <LoaderBuildWishList />
          ) : (
            <div className="grid grid-cols-4 gap-5 mb-10 w-full">
              {categories.map((event) => (
                <Link key={event.catValue} to={`/rental-all-products/${event.catValue}`}>
                  <div className="relative h-[400px] w-full">
                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src={event.singleImage}
                      alt=""
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black opacity-50"></div>
                    <section className="relative z-10 h-full">
                      <div className="flex justify-center flex-col items-center h-full">
                        <h1 className="text-white text-2xl font-raleway">
                          {event.category}
                        </h1>
                      </div>
                    </section>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RentalMainPage;